import { ActionButton } from 'components/button/button.styled'
import { ButtonContainer } from 'components/form/form.style'
import { useNavigate } from 'react-router-dom'

import { Container, Description, Header, Wrapper } from './notFoundContainer.style'

export const NotFoundContainer = () => {
    const navigate = useNavigate()

    const handleRedirect = () => {
        navigate(`/`)
    }

    return (
        <Container>
            <Wrapper>
                <Header>Valami nem stimmel...</Header>
                <Description>
                    A keresett oldal nem található. De sok más remek esemény igen! Böngéssz a legjobb találataink között...
                </Description>
                <ButtonContainer>
                    <ActionButton onClick={handleRedirect}>Tovább az előadásokra</ActionButton>
                </ButtonContainer>
            </Wrapper>
        </Container>
    )
}
